// eslint-disable-next-line no-unused-vars
import { useState } from 'react'

function defaultFunc() {}

const defaultAlert = {
  visible: false,
  title: '',
  type: 'warning',
  bodyText: '',
  showCancel: true,
  showConfirm: true,
  onConfirm: defaultFunc,
  onCancel: defaultFunc,
}

const useAlert = () => {
  const [alert, _setAlert] = useState(defaultAlert)

  const setTitle = (title: string) => _setAlert({ ...alert, title })
  const setType = (type: string) => _setAlert({ ...alert, type })
  const setVisible = (visible: boolean) => _setAlert({ ...alert, visible })
  const setBodyText = (bodyText: string) => _setAlert({ ...alert, bodyText })

  const resetAlert = () => _setAlert(defaultAlert)

  const setAlert = (_alert = {}) =>
    _setAlert((values) => ({
      ...values,
      ..._alert,
    }))

  return {
    alert,
    setAlert,
    setTitle,
    setType,
    setVisible,
    setBodyText,
    resetAlert,
  }
}

export default useAlert
